import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { DashboardLayout } from "../../Layout/DashboardLayout";
import CustomTable from "../CustomTable";
import { SCOFA_TABLE_HEADER_KEY } from "./ScofaAppData";
import ScofaAppColumn from "./ScofaAppColumn";
import CustomFilters from "../CustomFilters";
import CustomPagination from "../CustomPagination";
import BASEURL from "../../Config/global";
import CustomLoader from "../CustomLoader";
import { errorModal, successModal } from "../CustomModal";
import { UpatedScofaFlagInModule } from "../../Services/PatchApi";

const ImportDataFromRelax = ({ module = "articles", inModal = false, show, onHide, initialSelectedData = [], getCategoryData }) => {
  // const scofaColumnRef = useRef();
  const [data, setData] = useState([]);
  const [entries, setEntries] = useState(10);
  const [offset, setOffset] = useState(0);
  const [filterSearchValue, setFilterSearchValue] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [loader, setLoader] = useState(false);
  const [scofaFlagSelectedRows, setScofaFlagSelectedRows] = useState([]);

  // Initialize scofaFlagSelectedRows from initialSelectedData
  useEffect(() => {
    if (initialSelectedData?.length > 0) {
      const initial = initialSelectedData.map(item => ({ id: item.id, value: item.scofa_flag }));
      setScofaFlagSelectedRows(initial);
    } else {
      setScofaFlagSelectedRows([]);
    }
  }, [initialSelectedData, show, module]);

  // fetch immediately when entries, offset or module change
  useEffect(() => {
    fetchData();
  }, [entries, offset, module]);

  // debounce search term
  useEffect(() => {
    const handler = setTimeout(() => {
      fetchData();
    }, 500); // 500ms debounce

    return () => clearTimeout(handler);
  }, [filterSearchValue]);

  const fetchData = async () => {
    setLoader(true);
    try {
      let url;
      if (module === 'soundsmixture') {
        url = `${BASEURL}/api/sounds/set-mixer-category/?limit=${entries}&offset=${offset}&search=${filterSearchValue}`;
      } else {
        url = `${BASEURL}/api/${module}/?limit=${entries}&offset=${offset}&search=${filterSearchValue}`;
      }
      const response = await axios.get(url);
      if (!response.data.error) {
        setData(response.data.data);
        setTotalCount(response.data.count);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoader(false);
    }
  };

  const handleScofaFlagUpdate = async () => {
    try {
      setLoader(true);
      const payload = {
        data: scofaFlagSelectedRows,
        category_name: module
      };
      onHide();
      const result = await UpatedScofaFlagInModule(payload);
      setLoader(false);
      if (result?.status === 200) {
        getCategoryData();
        successModal.fire({
          text: "Scofa Changes Updated Successfully",
          confirmButtonText: "Continue",
        });
      }
    } catch (error) {
      setLoader(false);
      console.error("Update failed:", error);
    }
  };

  const titleMap = {
    articles: "Import Articles",
    soundsmixture: "Import Featured Mixes",
  };
  const innerContent = (
    <>
      <div className="row mb-3">
        <div className="col-lg-4 mb-2">
          <h2 className="mainTitle">{titleMap[module]}</h2>
        </div>
        <div className="col-lg-8 text-end mb-2">
          <button
            onClick={handleScofaFlagUpdate}
            className="customButton primaryButton me-3"
          >
            Update Scofa Tracks
          </button>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-12">
          <CustomFilters
            enteries={entries}
            totalCount={totalCount}
            entriesFilter={true}
            setEnteries={(val) => {
              setOffset(0);
              setEntries(val);
            }}
            filterSearch={true}
            filterSearchValue={filterSearchValue}
            setFilterSearchValue={setFilterSearchValue}
          />
        </div>
      </div>

      <div className="row mb-3 beautiful-scroll">
        <div className="col-12">
          <CustomTable
            headers={[
              SCOFA_TABLE_HEADER_KEY,
              // { key: "id", title: "S.No" },
              { key: "title", title: "Title" },
              // { key: "type", title: "Type" },
            ]}
          >
            <tbody>
              {loader ? (
                <tr>
                  <td colSpan={4} className="text-center py-5">
                    <div className="spinner-border" role="status"></div>
                  </td>
                </tr>
              ) : data &&
              data.map((item, index) => (
                <tr key={item.id}>


                  <td>
                    <div className='mt-2'>
                      <input
                        type="checkbox"
                        checked={scofaFlagSelectedRows.some(row => row.id === item.id && row.value === true)}
                        onChange={() => {
                          const isCurrentlySelected = scofaFlagSelectedRows.some(row => row.id === item.id && row.value === true);
                          const activeCount = scofaFlagSelectedRows.filter(row => row.value === true).length;

                          if (!isCurrentlySelected && activeCount >= 3) {
                            errorModal.fire({
                              text: "You can only select up to 3 items.",
                            });
                            return;
                          }

                          const newValue = !isCurrentlySelected;

                          setScofaFlagSelectedRows(prev => {
                            const exists = prev.find(row => row.id === item.id);
                            if (exists) {
                              return prev.map(row => row.id === item.id ? { ...row, value: newValue } : row);
                            } else {
                              return [...prev, { id: item.id, value: newValue }];
                            }
                          });
                        }}
                      />
                    </div>
                  </td>
                  <td>{item.title}</td>
                </tr>
              ))}

            </tbody>
          </CustomTable>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-12">
          <CustomPagination
            enteries={entries}
            totalCount={totalCount}
            setCurrentPage={setOffset}
            currentPage={offset}
          />
        </div>
      </div>

    </>
  );

  if (inModal) {
    return (
      <Modal dialogClassName='swap-modal-for-permission custom-modal' show={show} onHide={onHide} size="xl">
        <Modal.Header closeButton>
          {/* <Modal.Title>{titleMap[module] || titleMap.articles}</Modal.Title> */}
        </Modal.Header>
        <Modal.Body>
          {innerContent}

        </Modal.Body>
      </Modal>
    );
  }

  //   return <DashboardLayout>{innerContent}</DashboardLayout>;
};

export default ImportDataFromRelax;
